export const SubheadingSm = ({ title }: { title: string }) => {
  return (
    <div className="flex items-center justify-between gap-4">
      <h4 className="text-lg font-medium text-foreground">{title}</h4>
    </div>
  );
};
